$(function() {
	$.ajax({
		type: 'GET',
		url: '/wp-json/wp/v2/posts?_embed&per_page=3',
		dataType: 'json'
	}).done(function(json) {
		var html = '';
		//記事の件数分イテレートする
		$.each(json, function(i, row) {
			var date_data = new Date(row.date);
			var year = date_data.getFullYear();
			var month = date_data.getMonth() + 1;
			var day = date_data.getDate();
			var date = year + '.' + month + '.' + day;

			//ブログのタイトル
			var title = row.title.rendered;
			//ブログのURL
			var link = row.link;
			//ブログの本文
			var excerpt = row.excerpt.rendered;
			//サムネイル画像のURL
			var thumbnail
			if (row['_embedded']['wp:featuredmedia']) {
				thumbnail = row['_embedded']['wp:featuredmedia'][0]['media_details']['sizes']['thumbnail']['source_url']
			} else {
				thumbnail = "/img/noimage.png"
			}
			html += '<li>';
			html += '<a href="' + link + '" class="content">';
			html += '<figure class="image">';
			html += '<img src="' + thumbnail + '">';
			html += '</figure>';
			html += '<div class="container">';
			html += '<time class="date">' + date + '</time>';
			html += '<div class="title">' + title + '</div>';
			html += '</div>';
			html += '<svg class="icon icon-arrow">';
			html += '<use xlink:href="/img/sprite.svg#arrow"></use>';
			html += '</svg>';
			html += '</a>';
			html += '</li>';
		});
		//整形した記事の情報をページに追加する
		$('#js-news-list').append(html)
	}).fail(function(json) {
		console.error('記事取得に失敗しました')
	});
});
